import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AttributeCodec = t.intersection([
  t.type({
    Name: t.string,
    BSB: t.string,
    LAM: t.string,
    BUID: t.string,
    EBID: t.string,
    Address: t.string,
    Suburb: t.string,
    State: t.string,
    PostCode: t.string,
    Active: t.boolean
  }),
  t.partial({
  }),
]);

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const BranchCodec = t.type(
  {
    errors: tOptional(t.array(ErrorCodec)),
    data: tOptional(t.array(DataCodec)),
  },
  "BranchCodec"
);

export type Branch = t.TypeOf<typeof BranchCodec>;

export enum BranchActionTypes {
  FETCH = "@@branch/FETCH",
  FETCH_SUCCESS = "@@branch/FETCH_SUCCESS",
  FETCH_ERROR = "@@branch/FETCH_ERROR",
  SAVE_REQUEST = "@@branch/SAVE_REQUEST",
  SAVE_SUCCESS = "@@branch/SAVE_SUCCESS",
  SAVE_ERROR = "@@branch/SAVE_ERROR",
  DELETE_REQUEST = "@@branch/DELETE_REQUEST",
  DELETE_SUCCESS = "@@branch/DELETE_SUCCESS",
  DELETE_ERROR = "@@branch/DELETE_ERROR",
}

export interface BranchState {
  readonly loading: boolean;
  readonly data: Branch | undefined;
  readonly errors?: string;
}
